import React, {type ReactElement} from "react";
import {Helmet} from "react-helmet";

import {css} from "/src/utils/utils";
import * as styles from "./markdown-text.module.scss";

export enum MARKDOWN_TYPES {
  ARTICLE = "ARTICLE",
  DEFAULT = "DEFAULT",
  LEGAL = "LEGAL",
}

interface MarkdownTextProps {
  text?: string; // Deprecated - use htmlContent (make sure its pre-sanitized at build time)
  htmlContent?: string; // Pre-sanitized HTML from build-time
  classes?: string;
  type?: MARKDOWN_TYPES;
}

const MarkdownText = (props: MarkdownTextProps): ReactElement | null => {
  const {classes, htmlContent, type} = props;

  // htmlContent is pre-sanitized at build time. The `text` prop is deprecated
  // and has been removed to prevent insecure runtime rendering.
  // Make sure to add your field to `./gatsby-node.ts`
  // pre-sanitized happens here: `./src/utils/build/markdown-sanitizer.ts`
  const content = htmlContent || "";

  return content ? (
    <>
      {type === MARKDOWN_TYPES.LEGAL && (
        <Helmet>
          <script async src="//cdn.embedly.com/widgets/platform.js" />
        </Helmet>
      )}
      <div
        className={css(
          styles.markdownText,
          type === MARKDOWN_TYPES.ARTICLE ? styles.markdownTextArticle : "",
          type === MARKDOWN_TYPES.LEGAL ? styles.markdownTextLegal : "",
          classes!
        )}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    </>
  ) : null;
};

export default MarkdownText;
